export const customStyles = {
    tableWrapper: {
        style: {
            "padding-left": '0px',
            "padding-right": '0px',
            overflowY: 'visible',
            // overflowX: 'auto',
        }
    },
    rows: {
        style: {
            background: '#29b7b9',
            // minHeight: '60px', // override the row height
            minHeight: '30px', // override the row height

        },
    },
    columns: {
        style: {
            minWidth: '60px!important', // override the row height
        },
    },
    header: {
        style: {
            "border-radius": "10px",

        }
    },
    headCells: {
        style: {
            color: '#fff',
            background: '#29b7b9',
            minWidth: '30px!important', // override the row height
            textOverflow: 'clip',
            whiteSpace: 'normal'
        },
    },

    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            background: '#fff',
            minWidth: '30px!important', // override the row height
            // "overflow-x": "auto",
        },
    },
};
